/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject, Input, OnDestroy } from '@angular/core';
import { ChatField } from '@src/app/shared/chat/chat-field';
import { IsNarrowService } from '@src/app/shared/is-narrow.service';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { Follower } from '@src/app/model/user';
import { ConfirmDialogService } from '@src/app/shared/dialogs/confirmDialog';
import { MatDialog } from '@angular/material/dialog';
import { PersonPageComponent } from '@src/app/pages/person-page/person-page.component';
import { CurrentUserService } from '@src/app/modules/user/current-user.service';

@Component({
    selector: 'app-chat-followers',
    templateUrl: './chat-followers.component.html',
    styleUrls: ['./chat-followers.component.scss'],
    imports: [MatChipsModule, MatIconModule]
})
export class ChatFollowersComponent implements OnDestroy{

    isNarrow = inject(IsNarrowService);
    sub = this.isNarrow.detectVeryNarrow().subscribe((r) => this.isPhone = r);
    cds = inject(ConfirmDialogService);
    dialog = inject(MatDialog);
    currentUserSvc = inject(CurrentUserService);

    @Input() chatField: ChatField;
    @Input() allowRemove = true;

    newStyle = true;
    isPhone = false;

    remove(follower) {
        const chat = this.chatField.chat;
        const title = $localize`Remove Follower`;
        const message = $localize`Are you sure you want to remove ${follower.personFullName} from the followers of this chat?`;
        this.cds.open(title, message, () => {
            chat.service.stopFollowing(follower, true, chat.teamId).subscribe((success) => {
                if (success) {
                    this.chatField.removeFollower(follower);
                }
            });
        })
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    click(follower: Follower) {
        console.log('Follower clicked', follower);
        if (this.currentUserSvc.currentUser.currentTeam?.id !== follower.personTeamId
            && this.currentUserSvc.currentUser.inOmc?.teamId === follower.personTeamId
        ) {
            const title = $localize`Agency User`;
            const message = $localize`This is agency user ${follower.personFullName} from team ${follower.personTeamId}.
                You cannot view full profile details from here`;
            this.cds.alert(title, message);
            return;
        }
        const popDialogRef = this.dialog.open(PersonPageComponent,
            {
                data: {
                    id: follower.personId,
                    forceTeamId: follower.personTeamId
                }
            }
        );
        popDialogRef.afterClosed().subscribe(person => {
            if (person) {
                follower.personFullName = person.fullName;
            }
        })
    }
}
